import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5c63e986"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-12" }
const _hoisted_4 = { class: "card" }
const _hoisted_5 = { class: "card-header" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col-sm-12" }
const _hoisted_8 = { class: "nav" }
const _hoisted_9 = { class: "card-body" }
const _hoisted_10 = { class: "card-body" }
const _hoisted_11 = { class: "table table-responsive table-striped mb-0" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("colgroup", null, [
  /*#__PURE__*/_createElementVNode("col", {
    span: "1",
    style: {"width":"50%"}
  }),
  /*#__PURE__*/_createElementVNode("col", {
    span: "1",
    style: {"width":"50%"}
  })
], -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("h4", null, "Personal Information")
], -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("h4", null, "Candidate Self-Reported Information")
], -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("h4", null, "Charges or Violation of Law")
], -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("h4", null, "Education History")
], -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("h4", null, "Employment History")
], -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("h4", null, "Address History")
], -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("h4", null, "Screening Disclosure and Authorization")
], -1))
const _hoisted_20 = {
  key: 0,
  class: "d-flex justify-content-end"
}
const _hoisted_21 = /*#__PURE__*/_createTextVNode("Cancel")
const _hoisted_22 = ["disabled"]
const _hoisted_23 = ["disabled"]
const _hoisted_24 = {
  key: 1,
  class: "card-body"
}
const _hoisted_25 = { class: "table table-responsive table-striped mb-0" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("colgroup", null, [
  /*#__PURE__*/_createElementVNode("col", {
    span: "1",
    style: {"width":"50%"}
  }),
  /*#__PURE__*/_createElementVNode("col", {
    span: "1",
    style: {"width":"50%"}
  })
], -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("h4", null, "Document Type")
], -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("h4", null, "Official Document Front")
], -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("h4", null, "Official Document Back")
], -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("h4", null, "Selfie Image")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("ul", _hoisted_8, [
                  _createElementVNode("li", {
                    class: "nav-item",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.tab = 1))
                  }, [
                    _createElementVNode("h2", {
                      class: _normalizeClass(_ctx.tab == 1 ? 'nav-link active' : 'nav-link')
                    }, " Connected Form ", 2)
                  ]),
                  (_ctx.form.kyc)
                    ? (_openBlock(), _createElementBlock("li", {
                        key: 0,
                        class: _normalizeClass(_ctx.form.kyc ? 'nav-item' : 'nav-item disabled'),
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.tab = 2))
                      }, [
                        _createElementVNode("h2", {
                          class: _normalizeClass(_ctx.tab == 2 ? 'nav-link active' : 'nav-link')
                        }, " KYC ", 2)
                      ], 2))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            (_ctx.tab == 1)
              ? (_openBlock(), _createElementBlock("form", {
                  key: 0,
                  method: "POST",
                  onSubmit: _cache[4] || (_cache[4] = (e) => e.preventDefault())
                }, [
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("table", _hoisted_11, [
                      _hoisted_12,
                      _createElementVNode("tbody", null, [
                        _createElementVNode("tr", null, [
                          _hoisted_13,
                          _createElementVNode("td", null, [
                            _createElementVNode("span", {
                              class: _normalizeClass(["badge", 
                              _ctx.review.personal_info
                                ? 'badge-info'
                                : 'badge-danger'
                            ])
                            }, _toDisplayString(_ctx.getStatusMessage(_ctx.review.personal_info)), 3)
                          ])
                        ]),
                        _createElementVNode("tr", null, [
                          _hoisted_14,
                          _createElementVNode("td", null, [
                            _createElementVNode("span", {
                              class: _normalizeClass(["badge", 
                              _ctx.review.self_reported_info
                                ? 'badge-info'
                                : 'badge-danger'
                            ])
                            }, _toDisplayString(_ctx.getStatusMessage(_ctx.review.self_reported_info)), 3)
                          ])
                        ]),
                        _createElementVNode("tr", null, [
                          _hoisted_15,
                          _createElementVNode("td", null, [
                            _createElementVNode("span", {
                              class: _normalizeClass(["badge", 
                              _ctx.review.crimincal_history
                                ? 'badge-info'
                                : 'badge-danger'
                            ])
                            }, _toDisplayString(_ctx.getStatusMessage(_ctx.review.crimincal_history)), 3)
                          ])
                        ]),
                        _createElementVNode("tr", null, [
                          _hoisted_16,
                          _createElementVNode("td", null, [
                            _createElementVNode("span", {
                              class: _normalizeClass(["badge", 
                              _ctx.review.education_history
                                ? 'badge-info'
                                : 'badge-danger'
                            ])
                            }, _toDisplayString(_ctx.getStatusMessage(_ctx.review.education_history)), 3)
                          ])
                        ]),
                        _createElementVNode("tr", null, [
                          _hoisted_17,
                          _createElementVNode("td", null, [
                            _createElementVNode("span", {
                              class: _normalizeClass(["badge", 
                              _ctx.review.employment_history
                                ? 'badge-info'
                                : 'badge-danger'
                            ])
                            }, _toDisplayString(_ctx.getStatusMessage(_ctx.review.employment_history)), 3)
                          ])
                        ]),
                        _createElementVNode("tr", null, [
                          _hoisted_18,
                          _createElementVNode("td", null, [
                            _createElementVNode("span", {
                              class: _normalizeClass(["badge", 
                              _ctx.review.address_history
                                ? 'badge-info'
                                : 'badge-danger'
                            ])
                            }, _toDisplayString(_ctx.getStatusMessage(_ctx.review.address_history)), 3)
                          ])
                        ]),
                        _createElementVNode("tr", null, [
                          _hoisted_19,
                          _createElementVNode("td", null, [
                            _createElementVNode("span", {
                              class: _normalizeClass(["badge", 
                              _ctx.review.screening_disclosure
                                ? 'badge-info'
                                : 'badge-danger'
                            ])
                            }, _toDisplayString(_ctx.getStatusMessage(_ctx.review.screening_disclosure)), 3)
                          ])
                        ])
                      ])
                    ]),
                    (_ctx.roles.admin)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                          _createVNode(_component_router_link, {
                            to: { name: 'customer-form-submission' },
                            class: "btn btn-secondary w-md me-2"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_21
                            ]),
                            _: 1
                          }),
                          (_ctx.allApproved)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.submit(true))),
                                type: "submit",
                                class: "btn btn-primary w-md",
                                disabled: _ctx.reviewDisable
                              }, " Complete Review ", 8, _hoisted_22))
                            : (_openBlock(), _createElementBlock("button", {
                                key: 1,
                                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.submit(false))),
                                type: "submit",
                                class: "btn btn-danger w-md me-2",
                                disabled: _ctx.reviewDisable
                              }, " Decline Form ", 8, _hoisted_23))
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ], 32))
              : _createCommentVNode("", true),
            (_ctx.tab == 2 && _ctx.form.kyc)
              ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                  _createElementVNode("table", _hoisted_25, [
                    _hoisted_26,
                    _createElementVNode("tbody", null, [
                      _createElementVNode("tr", null, [
                        _hoisted_27,
                        _createElementVNode("td", null, [
                          _createElementVNode("span", {
                            class: _normalizeClass(["badge", 
                            _ctx.kycReview.doc_type ? 'badge-info' : 'badge-danger'
                          ])
                          }, _toDisplayString(_ctx.getStatusMessage(_ctx.kycReview.doc_type)), 3)
                        ])
                      ]),
                      _createElementVNode("tr", null, [
                        _hoisted_28,
                        _createElementVNode("td", null, [
                          _createElementVNode("span", {
                            class: _normalizeClass(["badge", 
                            _ctx.kycReview.official_doc
                              ? 'badge-info'
                              : 'badge-danger'
                          ])
                          }, _toDisplayString(_ctx.getStatusMessage(_ctx.kycReview.official_doc)), 3)
                        ])
                      ]),
                      _createElementVNode("tr", null, [
                        _hoisted_29,
                        _createElementVNode("td", null, [
                          _createElementVNode("span", {
                            class: _normalizeClass(["badge", 
                            _ctx.kycReview.official_doc_back
                              ? 'badge-info'
                              : 'badge-danger'
                          ])
                          }, _toDisplayString(_ctx.getStatusMessage(_ctx.kycReview.official_doc_back)), 3)
                        ])
                      ]),
                      _createElementVNode("tr", null, [
                        _hoisted_30,
                        _createElementVNode("td", null, [
                          _createElementVNode("span", {
                            class: _normalizeClass(["badge", 
                            _ctx.kycReview.live_photo ? 'badge-info' : 'badge-danger'
                          ])
                          }, _toDisplayString(_ctx.getStatusMessage(_ctx.kycReview.live_photo)), 3)
                        ])
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ])
  ]))
}